// Task-status ordering — shared so every consumer (Tasks list, Weekly Tasks,
// pickers) agrees with the Settings screen and the company sort-mode flag.
//
// The mode is the per-company MasterConfig flag ZCONFIGVAL_55_X
// (MasterConfigItem_Id 55, key `task_status_sort_mode`): '1' = A-Z by Name,
// anything else (incl. unset) = custom numeric `Order` (Name as tie-break).
// This mirrors TaskStatusController::list() so the order is correct even when
// the API list arrives unsorted/stale, and it lets us pass `sortByName={false}`
// to BadgeSelect (which otherwise force-sorts options alphabetically).

export const taskStatusSortIsAZ = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    return String(authUser?.get_configitem_data?.ZCONFIGVAL_55_X) === "1";
  } catch (e) {
    return false;
  }
};

// Returns a new array; does not mutate the input.
export const sortTaskStatuses = (list) => {
  const arr = [...(list || [])];
  if (taskStatusSortIsAZ()) {
    return arr.sort((a, b) => (a?.Name || "").localeCompare(b?.Name || ""));
  }
  return arr.sort((a, b) => {
    const ao = Number(a?.Order) || 0;
    const bo = Number(b?.Order) || 0;
    if (ao !== bo) return ao - bo;
    return (a?.Name || "").localeCompare(b?.Name || "");
  });
};
